import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Alert from '../Alert';

// Functions
import { closeSession } from '../Functions/closeSession.js';

export default function SessionMessage({ sessionMessage, history }) {
  const [alertOpen, setalertOpen] = useState(false);
  const [alertText, setAlertText] = useState('');

  const { t } = useTranslation('global');

  useEffect(() => {
    if (sessionMessage === '498' || sessionMessage === '499') {
      setalertOpen(true);
      setAlertText(sessionMessage === '498' ? t('sessionExpired') : t('invalidSession'));
    }
  }, [sessionMessage, t]);

  function alertCallback() {
    if (sessionMessage === '498' || sessionMessage === '499') closeSession(history, '/');
  }

  return (
    <Alert
      open={alertOpen}
      setOpen={setalertOpen}
      title={'Terramar'}
      text={alertText}
      callback={alertCallback}
    />
  );
}
